import { CSSProperties } from "@material-ui/core/styles/withStyles";

import { baseBody } from "../SuggestionBody.styles";
import { eventDateRow } from "../SuggestionBody.styles";
export { eventDateIcon, eventDate } from "../SuggestionBody.styles";

export const container: CSSProperties = {
  ...baseBody,
};

export const eventDateRowWithMargin: CSSProperties = {
  ...eventDateRow,
  marginBottom: 10,
};
